var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button-link',{staticClass:"mt-200 mb-100",on:{"click":_vm.goToIntegrationsTab}},[_vm._v("Back to Integrations")])
}
var staticRenderFns = []

export { render, staticRenderFns }